import {message, Tag} from "antd";
import SbomComponent from "../../domain/SbomComponent";

type Props = {
    component: SbomComponent,
    className?: string
};

function SbomComponentSourcePackageTag({component, className}: Props) {
    const sourcePackage = formatSourcePackage(component);

    if (!sourcePackage) {
        return null;
    }

    return <Tag title={sourcePackage}
                color={"geekblue"}
                className={className}
                onClick={event => {
                    event.preventDefault();
                    event.stopPropagation();

                    navigator.clipboard.writeText(sourcePackage);

                    message.info("Source package copied to clipboard.");
                }}>source</Tag>;
}

function formatSourcePackage(component: SbomComponent): string | undefined {
    if (component.sourcePurl) {
        return component.sourcePurl;
    }

    if (!component.sourceName) {
        return undefined;
    }

    return component.sourceVersion
        ? `${component.sourceName}@${component.sourceVersion}`
        : component.sourceName;
}

export default SbomComponentSourcePackageTag;
